var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LinkHover',{staticClass:"post",attrs:{"type":'router-link',"to":_vm.$trl({
        name: 'Article',
        params: {
            slug: _vm.post.customslug || _vm.post.slug,
            locale: _vm.$route.params.locale
        }
    })},scopedSlots:_vm._u([{key:"hover",fn:function(){return [_c('div',{staticClass:"hover content"},[_c('IconArrow'),_c('span',{staticClass:"caption"},[_vm._v("\n                "+_vm._s(_vm.post.name)+"\n            ")])],1)]},proxy:true}])},[_c('div',{staticClass:"default content"},[_c('IconArrow'),_c('span',{staticClass:"caption"},[_vm._v("\n            "+_vm._s(_vm.post.name)+"\n        ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }